import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "../lib/api";

export function ImageField({ value, onChange, inputCls, testid }) {
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setUploading(true);
    try {
      const { data } = await api.post("/admin/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(`${process.env.REACT_APP_BACKEND_URL}${data.url}`);
      toast.success("Imagine încărcată");
    } catch (err) {
      toast.error(apiError(err, "Încărcarea imaginii a eșuat"));
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      <div className="flex gap-2">
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={inputCls}
          placeholder="https://... sau încarcă de pe calculator"
          data-testid={testid}
        />
        <button
          type="button"
          onClick={() => fileRef.current?.click()}
          disabled={uploading}
          className="flex shrink-0 items-center gap-2 rounded-lg bg-navy px-4 text-xs font-bold text-white transition-colors hover:bg-navy disabled:opacity-60"
          data-testid={`${testid}-upload-button`}
        >
          {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
          {uploading ? "Se încarcă..." : "Încarcă"}
        </button>
        <input
          ref={fileRef}
          type="file"
          accept="image/jpeg,image/png,image/webp,image/gif"
          className="hidden"
          onChange={upload}
          data-testid={`${testid}-file-input`}
        />
      </div>
      {value && (
        <img
          src={value}
          alt="Previzualizare imagine"
          className="mt-2 h-16 w-16 rounded-lg border border-line object-cover"
          data-testid={`${testid}-preview`}
        />
      )}
    </div>
  );
}
